export class BaseState {
    viewModel = null;
}
